import { Link } from 'react-router-dom';
import { ArrowLeft, CalendarClock } from 'lucide-react';
import DesfasadosMes from '../components/DesfasadosMes';

/** /desfasados — la lista «Desfasados de <mes>» sola, para quien tiene Caja pero NO Finanzas (las cajeras).
 *  Mabel 4-nov-2026 (#1649): «las chicas no tienen acceso a la lista de desfasados». Quien sí tiene Finanzas
 *  llega a la misma lista por Finanzas › Adeudos (la tarjeta del Inicio decide a dónde mandar). El dato viene
 *  de GET /finances/debts, que ya acepta Caja o Finanzas. */
export default function DesfasadosPage() {
  return (
    <div data-testid="desfasados-page">
      <div className="mb-4 flex items-center justify-between gap-3">
        <h2 className="flex items-center gap-2 font-display text-2xl font-bold text-content">
          <CalendarClock size={20} className="text-amber-600 dark:text-amber-400" /> Desfasados
        </h2>
        <Link to="/" className="flex items-center gap-1 text-xs font-medium text-brand-blue hover:underline"><ArrowLeft size={14} /> Inicio</Link>
      </div>
      <DesfasadosMes resaltar />
    </div>
  );
}
